import Plugin     from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import uppercaseIcon from "./icons/uppercase-icon";

export default class Capitalize extends Plugin {

    init() {
        const editor = this.editor;

        editor.model.schema.extend('$text', {allowAttributes: 'capitalize'});
        editor.conversion.attributeToElement({
            model: 'capitalize',
            view: {
                name: 'span',
                styles: {
                    'text-transform': 'capitalize'
                }
            }
        });

        editor.model.schema.extend('$text', {allowAttributes: 'uppercase'});
        editor.conversion.attributeToElement({
            model: 'uppercase',
            view: {
                name: 'span',
                styles: {
                    'text-transform': 'uppercase'
                }
            }
        });

        editor.ui.componentFactory.add('Capitalize', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Capitalize',
                withText: true,
                tooltip: true,
                isToggleable: true
            });

            // Callback executed once the button is clicked.
            view.on('execute', () => {
                const selection     = editor.model.document.selection;
                const range         = selection.getFirstRange();
                const isCapitalised = selection.hasAttribute('capitalize');

                if (!isCapitalised) {
                    editor.model.change(writer => {
                        writer.setAttribute('capitalize', true, range);
                    });
                } else {
                    editor.model.change(writer => {
                        writer.removeAttribute('capitalize', range);
                    });
                }
            });
            return view;
        });

        editor.ui.componentFactory.add('Uppercase', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Uppercase',
                withText: false,
                tooltip: true,
                isToggleable: true,
                icon: uppercaseIcon
            });

            // Callback executed once the button is clicked.
            view.on('execute', () => {
                const selection   = editor.model.document.selection;
                const range       = selection.getFirstRange();
                const isUppercase = selection.hasAttribute('uppercase');

                if (!isUppercase) {
                    editor.model.change(writer => {
                        writer.setAttribute('uppercase', true, range);
                    });
                } else {
                    editor.model.change(writer => {
                        writer.removeAttribute('uppercase', range);
                    });
                }
            });
            return view;
        });
    }
}